import { render, staticRenderFns } from "./BroadcastConfirm.vue?vue&type=template&id=3bb14670"
import script from "./BroadcastConfirm.vue?vue&type=script&lang=js"
export * from "./BroadcastConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports